import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	productDiscoveryHandbook: {
		id: 'polaris-components-quickstart.onboarding-check-list-post-tasks.product-discovery-handbook.non-final',
		defaultMessage: 'Product Discovery Handbook',
		description: 'Link to the Product Discovery Handbook',
	},
	communityFaq: {
		id: 'polaris-components-quickstart.onboarding-check-list-post-tasks.community-faq.non-final',
		defaultMessage: 'Community FAQ',
		description: 'Link to the Community FAQ',
	},
	courseDeepDive: {
		id: 'polaris-components-quickstart.onboarding-check-list-post-tasks.course-deep-dive.non-final',
		defaultMessage: 'Course deep dive',
		description: 'Link to the Course deep dive',
	},
});
